var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.667 26.668 50 40.002 36.667 53.335",
    fill: "#009DF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.667 26.668 50 40.002 36.667 53.335V26.668Z",
    stroke: "#0098EB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgPlay;